import { PawPrint, TrendingUp } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost2Stats = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  const stats = [
    { number: "500+", label: "Schronisk na mapie", color: "#4E8A6E" },
    { number: "24/7", label: "Dostęp online", color: "#8B5CF6" },
    { number: "100%", label: "Za darmo", color: "#F97316" },
  ];
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "80px 60px",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "12px",
              background: "#4E8A6E",
              padding: "14px 32px",
              borderRadius: "100px",
              marginBottom: "28px",
              boxShadow: "0 8px 32px rgba(78, 138, 110, 0.3)",
            }}
          >
            <TrendingUp style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
            <span style={{ fontSize: "24px", fontWeight: 700, color: "#FFFFFF" }}>
              Liczby mówią same za siebie
            </span>
          </div>
          <h1
            style={{
              fontSize: "76px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: "0",
              lineHeight: 1.1,
            }}
          >
            Dlaczego warto?
          </h1>
        </div>

        {/* Stats cards */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
            maxWidth: "800px",
          }}
        >
          {stats.map((stat, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.97)",
                borderRadius: "28px",
                padding: "32px 48px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 12px 40px rgba(0,0,0,0.06)",
                borderLeft: `8px solid ${stat.color}`,
              }}
            >
              <span
                style={{
                  fontSize: "72px",
                  fontWeight: 800,
                  color: stat.color,
                  lineHeight: 1,
                }}
              >
                {stat.number}
              </span>
              <span
                style={{
                  fontSize: "32px",
                  fontWeight: 700,
                  color: "#2D5A3D",
                  textAlign: "right",
                }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <p
            style={{
              fontSize: "28px",
              fontWeight: 600,
              color: "#6B8A7A",
              margin: 0,
            }}
          >
            Dołącz do pomagających! 🐾
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "56px",
                height: "56px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko
            </span>
          </div>
        </div>
      </div>
    </GraphicBackground>
  );
};

